import { AlertCircle } from "lucide-react";

/**
 * Site-wide closed-loop economy disclosure.
 *
 * Drop anywhere users are about to spend, wager, enter, or trade — the
 * legal team asked for this notice on registration, credit purchase,
 * pack purchase, marketplace, competition entries, Terms, and FAQ.
 *
 * Variants:
 *   • `compact` — one-line inline strip (default)
 *   • `card`    — bordered card with icon + fuller text (for tops of pages)
 */
/** Compliance Roadmap Item 1 — canonical business-model description.
 *  Kept alongside the closed-loop disclosure so users see both the business
 *  model AND the no-cash-value rules from a single amber block. */
const BUSINESS_MODEL_LINE = "A closed-loop, 21+ digital collectible card game offering randomized digital collectibles, skill-based competitions, social features, and in-platform rewards.";

export function ClosedLoopNotice({ variant = "compact", className = "", testid = "closed-loop-notice", withBusinessModel = false }) {
  const body = (
    <>
      <span className="font-semibold text-white/90">Playden is a closed-loop entertainment platform.</span>{" "}
      Credits, cards, equipment, and other digital items have no cash value and cannot be withdrawn, redeemed for money, converted back into cryptocurrency, or sold outside Playden.
    </>
  );

  if (variant === "card") {
    return (
      <div
        data-testid={testid}
        className={`rounded-xl border border-amber-400/30 bg-amber-500/[0.06] p-3.5 flex items-start gap-2.5 ${className}`}
      >
        <AlertCircle className="h-4 w-4 shrink-0 mt-0.5 text-amber-300" />
        <div className="text-[12px] leading-relaxed text-amber-100/95">
          <div className="font-mono uppercase tracking-[0.16em] text-[10px] font-semibold text-amber-200 mb-1">
            Closed-loop economy
          </div>
          {withBusinessModel && (
            <p className="text-white/90 mb-1.5" data-testid={`${testid}-business-model`}>
              {BUSINESS_MODEL_LINE}
            </p>
          )}
          {body}
        </div>
      </div>
    );
  }

  return (
    <div
      data-testid={testid}
      className={`text-[11px] leading-relaxed text-white/55 flex items-start gap-1.5 ${className}`}
    >
      <AlertCircle className="h-3 w-3 shrink-0 mt-0.5 text-amber-300/70" />
      <span>
        {withBusinessModel && (
          <>
            <span className="text-white/85" data-testid={`${testid}-business-model`}>{BUSINESS_MODEL_LINE}</span>{" "}
          </>
        )}
        {body}
      </span>
    </div>
  );
}

export default ClosedLoopNotice;
